<div class="steps-shell steps-shell--loading" [class.is-loading]="isLoading"
  [class.is-visible]="isLoading && showLoadingSkeleton"
  [attr.aria-hidden]="isLoading && showLoadingSkeleton ? null : 'true'">
  <nav class="stepper stepper-skeleton" aria-label="Carregando etapas da votação">
    <article class="step-skeleton">
      <ejs-skeleton shape="Circle" width="32px" height="32px"></ejs-skeleton>
      <div class="step-skeleton-copy">
        <ejs-skeleton shape="Text" width="44px" height="11px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="74px" height="13px"></ejs-skeleton>
      </div>
    </article>
    <article class="step-skeleton">
      <ejs-skeleton shape="Circle" width="32px" height="32px"></ejs-skeleton>
      <div class="step-skeleton-copy">
        <ejs-skeleton shape="Text" width="44px" height="11px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="58px" height="13px"></ejs-skeleton>
      </div>
    </article>
    <article class="step-skeleton">
      <ejs-skeleton shape="Circle" width="32px" height="32px"></ejs-skeleton>
      <div class="step-skeleton-copy">
        <ejs-skeleton shape="Text" width="44px" height="11px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="66px" height="13px"></ejs-skeleton>
      </div>
    </article>
  </nav>

  <section class="step-panel step-panel-skeleton" aria-label="Carregando conteúdo da votação">
    <div class="panel-grid panel-grid--intro">
      <div class="panel-card panel-card--content panel-card--skeleton">
        <ejs-skeleton shape="Rectangle" width="142px" height="32px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="78%" height="36px"></ejs-skeleton>

        <div class="skeleton-lines">
          <ejs-skeleton shape="Text" width="98%" height="17px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="88%" height="17px"></ejs-skeleton>
        </div>

        <div class="info-card-grid info-card-grid--skeleton">
          <article class="info-card info-card--skeleton" *ngFor="let card of [1, 2, 3]">
            <ejs-skeleton shape="Text" width="68%" height="13px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="72%" height="20px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="84%" height="14px"></ejs-skeleton>
          </article>
        </div>

        <div class="intro-copy-skeleton">
          <ejs-skeleton shape="Text" width="42%" height="24px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="100%" height="17px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="94%" height="17px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="82%" height="17px"></ejs-skeleton>
        </div>
      </div>

      <div class="support-column support-column--skeleton">
        <div class="client-brand client-brand--skeleton">
          <ejs-skeleton shape="Rectangle" width="72%" height="56px"></ejs-skeleton>
        </div>

        <div class="panel-card panel-card--support panel-card--skeleton">
          <ejs-skeleton shape="Text" width="64%" height="28px"></ejs-skeleton>

          <div class="topics-list topics-list--skeleton">
            <article class="topic-card topic-card--skeleton" *ngFor="let topic of [1, 2, 3]">
              <ejs-skeleton shape="Circle" width="38px" height="38px"></ejs-skeleton>
              <div class="topic-card-skeleton-copy">
                <ejs-skeleton shape="Text" width="72%" height="18px"></ejs-skeleton>
                <ejs-skeleton shape="Text" width="96%" height="14px"></ejs-skeleton>
                <ejs-skeleton shape="Text" width="78%" height="14px"></ejs-skeleton>
              </div>
            </article>
          </div>

          <ejs-skeleton shape="Rectangle" width="100%" height="54px"></ejs-skeleton>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-container *ngIf="votingData as data">
  <nav class="stepper" #stepperEl aria-label="Etapas da votação">
    <div class="step" [class.is-active]="currentStep === 1" [class.is-complete]="currentStep > 1">
      <div class="step-node" aria-hidden="true">
        <i *ngIf="currentStep > 1" class="fa fa-check"></i>
        <span *ngIf="currentStep <= 1">1</span>
      </div>
      <div class="step-label">
        <small class="step-caption">ETAPA 1</small>
        <strong class="step-title">Apresentação</strong>
        <span class="step-status">{{ currentStep > 1 ? 'Concluída' : 'Em andamento' }}</span>
      </div>
    </div>

    <div class="step" [class.is-active]="currentStep === 2" [class.is-complete]="currentStep > 2">
      <div class="step-node" aria-hidden="true">
        <i *ngIf="currentStep > 2" class="fa fa-check"></i>
        <span *ngIf="currentStep <= 2">2</span>
      </div>
      <div class="step-label">
        <small class="step-caption">ETAPA 2</small>
        <strong class="step-title">Escolha</strong>
        <span class="step-status">{{ currentStep > 2 ? 'Concluída' : (currentStep === 2 ? 'Em andamento' : 'Pendente') }}</span>
      </div>
    </div>

    <div class="step" [class.is-active]="currentStep === 3" [class.is-complete]="currentStep === 3">
      <div class="step-node" aria-hidden="true">
        <i *ngIf="currentStep === 3" class="fa fa-check"></i>
        <span *ngIf="currentStep < 3">3</span>
      </div>
      <div class="step-label">
        <small class="step-caption">ETAPA 3</small>
        <strong class="step-title">Protocolo</strong>
        <span class="step-status">{{ currentStep === 3 ? 'Concluída' : 'Pendente' }}</span>
      </div>
    </div>
  </nav>

  <section class="step-panel" *ngIf="currentStep === 1">
    <div class="panel-grid panel-grid--intro">
      <div class="panel-card panel-card--content">
        <span class="section-chip">Sobre a eleição</span>
        <h2 class="section-title">{{ data.election.name }}</h2>
        <p class="section-description">{{ data.election.description }}</p>

        <div class="info-card-grid">
          <article class="info-card" *ngFor="let card of data.infoCards">
            <span class="info-card-label">{{ card.label }}</span>
            <strong class="info-card-value">{{ card.value }}</strong>
            <span class="info-card-helper" *ngIf="card.helper">{{ card.helper }}</span>
          </article>
        </div>

        <div class="content-block">
          <h3>O que é a CIPA?</h3>
          <p>{{ data.cipaDescription }}</p>
        </div>

        <div class="content-block">
          <h3>Orientações para votar</h3>
          <ul class="guideline-list">
            <li *ngFor="let guideline of data.votingGuidelines">{{ guideline }}</li>
          </ul>
        </div>
      </div>

      <div class="support-column">
        @if (data.election.companyLogoUrl) {
          <div class="client-brand" aria-label="Empresa participante">
            <img [src]="data.election.companyLogoUrl" alt="Logo da empresa">
          </div>
        }

        <div class="panel-card panel-card--support">
          <div class="topics-list">
            <article class="topic-card" *ngFor="let topic of data.introTopics">
              <span class="topic-icon"><i [class]="topic.icon" aria-hidden="true"></i></span>
              <div>
                <h3>{{ topic.title }}</h3>
                <p>{{ topic.description }}</p>
              </div>
            </article>
          </div>

          <button ejs-button cssClass="hero-action-button flow-button flow-button--primary e-primary" type="button"
            (click)="startVoting()">
            Iniciar votação agora
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="step-panel" *ngIf="currentStep === 2">
    <div class="panel-card panel-card--content panel-card--selection">
      <div class="section-header">
        <div>
          <span class="section-chip">Etapa de escolha</span>
          <h2 class="section-title">Selecione até {{ maxVotesPerVoter }} candidatos</h2>
          <p class="section-description">
            Toque ou clique nos cartões para marcar seus candidatos. Se preferir, você também pode selecionar a opção de voto em branco antes do registro final.
          </p>
        </div>
        <div class="selection-summary">
          <span class="selection-count">{{ hasBlankVoteSelected ? 'Branco' : selectedCandidateIds.length + '/' + maxVotesPerVoter }}</span>
          <span class="selection-label">{{ hasBlankVoteSelected ? 'selecionado' : 'selecionados' }}</span>
        </div>
      </div>

      <div class="feedback-banner feedback-banner--warning" *ngIf="warningMessage">
        {{ warningMessage }}
      </div>

      <div class="feedback-banner feedback-banner--error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <app-candidate-grid
        [candidates]="candidateCards"
        [selectionEnabled]="true"
        [selectionDisabled]="isVoteInteractionLocked"
        [maxSelectable]="maxVotesPerVoter"
        [selectedCandidateIds]="selectedCandidateIds"
        (selectedCandidateIdsChange)="handleSelectedCandidateIdsChange($event)"
        (selectionLimitReached)="handleSelectionLimitReached($event)">
      </app-candidate-grid>

      <div class="panel-actions">
        <button ejs-button cssClass="flow-button flow-button--secondary e-flat" type="button"
          [disabled]="isVoteInteractionLocked"
          (click)="returnToIntroduction()">
          Voltar
        </button>
        <button ejs-button cssClass="flow-button flow-button--primary e-primary" type="button"
          [disabled]="!canSubmitVote || isVoteInteractionLocked" (click)="submitVote()">
          {{ isSubmitting ? 'Registrando...' : submitButtonLabel }}
        </button>
      </div>
    </div>
  </section>

  <section class="step-panel" *ngIf="currentStep === 3 && voteReceipt">
    <div class="panel-grid panel-grid--finish">
      <div class="panel-card panel-card--success">
        <span class="section-chip">Votação concluída</span>
        <h2 class="section-title">Obrigado pela sua participação! <span class="title-celebration"
            aria-hidden="true">🎉</span></h2>
        <p class="section-description">
          Seu registro foi concluído com sucesso. Guarde o protocolo abaixo como comprovante da sua participação.
        </p>

        <div class="protocol-box">
          <span class="protocol-label">Protocolo da votação</span>
          <strong class="protocol-value">{{ voteReceipt.protocol }}</strong>
          <span class="protocol-date">Registrado em {{ voteReceipt.registeredAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>

      <div class="panel-card panel-card--support panel-card--success-support">
        <span class="section-chip">Resumo da participação</span>
        <h3>{{ hasBlankVoteSelected ? 'Voto em branco registrado' : 'Seus candidatos registrados' }}</h3>
        <p class="support-description">
          {{ hasBlankVoteSelected
            ? 'Sua participação foi registrada como voto em branco. O voto é sigiloso e não fica associado ao seu protocolo.'
            : 'Estes foram os candidatos escolhidos na sua votação. O voto é sigiloso e não fica associado ao seu protocolo.' }}
        </p>

        <div *ngIf="hasBlankVoteSelected; else selectedCandidatesList" class="protocol-box protocol-box--neutral">
          <span class="protocol-label">Opção registrada</span>
          <strong class="protocol-value">Voto em branco</strong>
          <span class="protocol-date">Nenhum candidato foi associado a esta participação.</span>
        </div>

        <ng-template #selectedCandidatesList>
          <ul class="selected-list">
            <li *ngFor="let candidate of selectedCandidates">
              <span class="selected-badge">{{ candidate.candidateNumber }}</span>
              <div>
                <strong>{{ candidate.name }}</strong>
                <span>{{ candidate.position }} • {{ candidate.department }}</span>
              </div>
            </li>
          </ul>
        </ng-template>

        <div class="support-actions">
          <button ejs-button cssClass="flow-button flow-button--secondary e-flat" type="button"
            (click)="resetExperience()">
            Voltar ao início
          </button>
        </div>
      </div>
    </div>

    <div class="password-setup-notice" *ngIf="hasPasswordConfigured === false">
      <div class="password-setup-notice__content">
        <span class="password-setup-notice__icon" aria-hidden="true">🔐</span>
        <div>
          <strong class="password-setup-notice__title">Reforce a segurança do seu acesso</strong>
          <p class="password-setup-notice__text">
            Você ainda não tem uma senha cadastrada. Criar uma senha torna o seu acesso mais seguro e independente.
          </p>
        </div>
      </div>
      <button ejs-button type="button" cssClass="e-fabric e-primary password-setup-notice__action" routerLink="/conta">
        Cadastrar senha
      </button>
    </div>
  </section>
</ng-container>
